<script setup>
const props = defineProps({
    blok: {
        type: Object,
    },
})

const media = computed(() => ({
    ...props.blok.media,
    src: props.blok.media.filename
}))
</script>
<template>
    <div class="!shadow-custom-lg p-6 mb-custom-lg max-w-xs border-r-3 border-secondary-red-100 rounded-sm">
        <div class="mb-4 text-xl font-bold capitalize">
            {{ blok?.title }}
        </div>
        <a :href="blok?.link ? blok?.link : blok?.media" target="_blank" class="!no-underline blok bg-red-gradient py-2.5 px-3 !text-white rounded-md font-semibold leading-6 transition-shadow duration-200 ease-in-out disabled:cursor-not-allowed disabled:opacity-50">
            Download2
        </a>
    </div>
</template>